export const MetricTable = ({ columns, rows, total, prefix, firstLabel }) => (
  <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900" data-testid={`${prefix}-table`}>
    <table className="log-table">
      <thead>
        <tr>
          <th className="log-first">{firstLabel}</th>
          {columns.map((c) => <th key={c.key} className="text-right">{c.label}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.rep_id} data-testid={`${prefix}-row-${r.rep_id}`}>
            <td className="log-first font-semibold text-slate-50">{r.active ? r.name : `${r.name} (inactive)`}</td>
            {columns.map((c) => <td key={c.key} data-testid={`${prefix}-${r.rep_id}-${c.key}`} className="text-right font-mono">{c.fmt(r[c.key])}</td>)}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={columns.length + 1} className="text-center text-slate-500">No reps with data in this range</td></tr>
        )}
        <tr data-testid={`${prefix}-row-total`}>
          <td className="log-first !bg-[#172033] font-bold text-slate-50">Team total</td>
          {columns.map((c) => <td key={c.key} data-testid={`${prefix}-total-${c.key}`} className="!bg-[#172033] text-right font-mono font-semibold text-slate-50">{c.fmt(total[c.key])}</td>)}
        </tr>
      </tbody>
    </table>
  </div>
);

export const SectionHead = ({ title, sub }) => (
  <div className="mb-3">
    <h2 className="font-display text-base font-bold text-slate-50 md:text-lg">{title}</h2>
    {sub && <p className="text-xs text-slate-400">{sub}</p>}
  </div>
);
